module.exports = __webpack_public_path__ + "img/0220622144038.3d8c41fb.png";